import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import {
  startForegroundPushDelivery,
  stopForegroundPushDelivery,
} from '../../services/pushNotificationService';
import { usePushActivation } from '../../hooks/usePushActivation';

const PushNotificationsBootstrap: React.FC = () => {
  const { currentUser } = useAuth();
  const { snapshot } = usePushActivation();

  useEffect(() => {
    if (!currentUser?.uid || snapshot.uid !== currentUser.uid || snapshot.status !== 'active') {
      stopForegroundPushDelivery();
      return;
    }

    startForegroundPushDelivery();
    return () => stopForegroundPushDelivery();
  }, [currentUser?.uid, snapshot.uid, snapshot.status]);

  useEffect(() => {
    if (snapshot.status === 'error' && snapshot.error) {
      console.warn('[Push] Nie udalo sie odczytac aktywacji aktualnej instalacji:', snapshot.error);
    }
  }, [snapshot.status, snapshot.error]);

  return null;
};

export default PushNotificationsBootstrap;
